/* eslint-disable react/prop-types */
import React from 'react';
import Select from 'react-select';
import { useSearchParams, useNavigate } from 'react-router-dom';

const Filters = ({ path, categories }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const selectedId = Number(searchParams.get('category'));
  const options = [
    { label: 'All', value: '' },
    ...categories.map((c) => ({
      label: c.name,
      value: c.id,
    })),
  ];
  return (
    <div className="filters">
      <label id="category-label" htmlFor="category-select">
        Filter Posts
      </label>
      <Select
        aria-labelledby="category-label"
        classNamePrefix="rs"
        className="category-select"
        isSearchable={false}
        options={options}
        placeholder="Choose a category"
        value={options.find((c) => (c.value === selectedId) || null)}
        onChange={(option) => {
          const params = new URLSearchParams(searchParams);
          if (option) {
            params.set('category', option.value);
          } else {
            params.delete('category');
          }
          navigate(`${path}?${params.toString()}`);
        }}
      />
    </div>
  );
};

export default Filters;
